export default __webpack_public_path__ + "static/media/0_0_0_0_70_http _img.haymarketsac.in_autocarpro_8edde8e7-003d-4cc5-9c70-fc922518cfb6.f336e0d2.jpg";